import React from 'react';

/**
 * Komponen placeholder untuk menambah kartu baru
 * @param {boolean} isDarkMode - Status dark mode
 * @param {function} onClick - Callback saat diklik
 * @param {string} label - Label tombol
 */
const AddCardPlaceholder = ({ isDarkMode, onClick, label = "Add New", aspectRatio }) => {
    const ratioClass = aspectRatio ? '' : 'md:aspect-[3/4]';
    return (
        <div
            onClick={onClick}
            className={`
                h-24 md:h-auto ${ratioClass} rounded-xl border border-dashed flex flex-col items-center justify-center 
                cursor-pointer transition-colors group
                ${isDarkMode ? 'border-slate-700 hover:bg-slate-800' : 'border-slate-300 hover:bg-slate-50'}
            `}
            style={aspectRatio ? { aspectRatio } : undefined}
        >
            <div className={`
            w-10 h-10 rounded-full flex items-center justify-center mb-2 
            group-hover:scale-110 transition-transform 
            ${isDarkMode ? 'bg-slate-800 text-slate-400' : 'bg-slate-100'}
        `}>
                <span className="text-xl text-slate-400 font-light">+</span>
            </div>
            <span className="text-[10px] md:text-xs text-slate-400 font-medium">
                {label}
            </span>
        </div>
    );
};

export default AddCardPlaceholder;
